import { RadioGroup as ChakraRadioGroup } from '@chakra-ui/react'
import * as React from 'react'

export interface RadioProps extends ChakraRadioGroup.ItemProps {
  size?: 'sm' | 'md' | 'lg'
  rootRef?: React.Ref<HTMLDivElement>
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
}

export const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
  function Radio(props, ref) {
    const {
      children,
      inputProps,
      rootRef,
      size,
      fontSize = 'md',
      ...rest
    } = props
    const hoverBgSize =
      size === 'md'
        ? 'var(--chakra-sizes-7)'
        : size === 'lg'
          ? 'var(--chakra-sizes-8)'
          : 'var(--chakra-sizes-6)'

    return (
      <ChakraRadioGroup.Item
        ref={rootRef}
        alignItems="start"
        position="relative"
        {...rest}
      >
        <ChakraRadioGroup.ItemHiddenInput ref={ref} {...inputProps} />
        <ChakraRadioGroup.ItemIndicator
          borderWidth="2px"
          borderColor="gray.500"
          _checked={{
            borderColor: 'colorPalette.500',
            bg: 'colorPalette.500',
          }}
          _disabled={{
            borderColor: 'gray.200',
            bg: 'gray.200',
          }}
          _readOnly={{
            borderColor: 'gray.500',
            bg: 'white',
            color: 'gray.500',
            opacity: 'disabled',
            _checked: {
              opacity: 1,
              bg: 'gray.200',
              borderColor: 'gray.200',
            },
            _hover: {
              '&::before': {
                display: 'none',
              },
            },
          }}
          _hover={{
            '&::before': {
              content: '""',
              bgColor: 'colorPalette.500/8',
              position: 'absolute',
              width: hoverBgSize,
              height: hoverBgSize,
              borderRadius: 'full',
            },
          }}
          css={{
            '&:is(:checked, [data-checked], [aria-checked=true], [data-state=checked]):is(:disabled, [disabled], [data-disabled], [aria-disabled=true])':
              {
                borderColor: 'gray.200',
                bg: 'gray.200',
                '& .dot': {
                  bg: 'gray.500',
                },
              },
          }}
        />
        {children && (
          <ChakraRadioGroup.ItemText
            fontWeight="normal"
            fontSize={fontSize}
            _disabled={{ opacity: 'disabled' }}
          >
            {children}
          </ChakraRadioGroup.ItemText>
        )}
      </ChakraRadioGroup.Item>
    )
  },
)

export const RadioGroup = React.forwardRef<
  HTMLDivElement,
  ChakraRadioGroup.RootProps
>(function RadioGroup({ size = 'md', ...props }, ref) {
  return <ChakraRadioGroup.Root ref={ref} size={size} {...props} />
})
